<template>
    <div class="loginBox">
        <div>
            <img src="../assets/imgs/login/login_logo.png" alt="">
            <!-- <transition enter-active-class="animated flipInY" leave-active-class="animated flipOutY"> -->
                <div class="loginCon" v-if="type == 'login'">
                    <h2>登录</h2>
                    <div class="loginUserNameBox">
                        <div class="icon"></div>
                        <i></i>
                        <input type="text" placeholder="请输入您的账号" v-model="loginUserName">
                    </div>
                    <div class="loginPasswordBox">
                        <div class="icon"></div>
                        <i></i>
                        <input type="text" placeholder="请输入您的密码" v-model="loginPassword" v-show="isShowPwd">
                        <input type="password" placeholder="请输入您的密码" v-model="loginPassword" v-show="!isShowPwd">
                        <div class="hidePwd" :class=" isShowPwd ? 'showPwd' : '' " @mousedown="isShowPwd = !isShowPwd" @mouseup="isShowPwd = !isShowPwd"></div>
                    </div>
                    <div class="otherBtn">
                        <p class="registerBtn" @click="type = 'register'">新用户注册</p>
                    </div>
                    <div class="loginBtn" @click="login"></div>
                    <p class="errMsg">{{ loginErrMsg }}</p>
                    <!-- <div class="otherLoginBtn">
                        <p>————&nbsp;&nbsp;快捷登录&nbsp;&nbsp;————</p>
                        <div class="wechatBtn"></div>
                    </div> -->
                </div>
            <!-- </transition> -->
            <!-- <transition enter-active-class="animated flipInY" leave-active-class="animated flipOutY"> -->
                <div class="registerCon" v-if="type == 'register'">
                    <h2>注册</h2>
                    <ul>
                        <li>
                            <p>输入昵称：</p>
                            <input type="text" v-model="registerNickName" placeholder="请输入昵称">
                            <span>*</span>
                        </li>
                        <li>
                            <p>输入账号：</p>
                            <input type="text" v-model="registerUserName" placeholder="请输入账号">
                            <span>*</span>
                        </li>
                        <li>
                            <p>输入密码：</p>
                            <input type="password" v-model="registerPaw" placeholder="请输入密码">
                            <span>*</span>
                        </li>
                        <li>
                            <p>确认密码：</p>
                            <input type="password" v-model="registeredPaw" placeholder="确认密码">
                            <span>*</span>
                        </li>
                    </ul>
                    <div @click="defineRegister"></div>
                    <p class="errMsg">{{ registerErr }}</p>
                </div>
            <!-- </transition> -->
        </div>
    </div>
</template>

<script>
let Base64 = require('js-base64').Base64;
export default {
    
    data() {
        return {
            type: "login",
            loginUserName: "",
            loginPassword: "",
            loginErrMsg: "",
            isShowPwd: false,
            // 注册/忘记密码
            registerNickName: null,
            registerUserName: null,
            registerPaw: null,
            registeredPaw: null,
            registerErr: "",
        }
    },
    mounted() {
        // let that = this;
        // that.bottomInfo();
    },
    methods: {
        login() {
            let that = this;
            if( !that.commin.fn.trim( that.loginUserName ) ) {
                that.loginErrMsg = '账号不能为空';
                return false;
            }
            if( that.loginPassword.length < 0 ) {
                that.loginErrMsg = '密码不能为空';
                return false;
            }
            let data = new FormData();
            data.append("username", that.commin.fn.trim( that.loginUserName ));
            data.append("password", that.$md5(that.loginPassword));

            that.allApi.login(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    that.$router.push("/");
                    sessionStorage.setItem("online", true);
                    that.$store.commit("setOnline", true);
                    sessionStorage.setItem("nickName", resource.data.data.nickname);
                    console.log(resource.data.data.admin)
                    if( resource.data.data.admin ) {
                        sessionStorage.setItem("admin", true);
                        that.$store.commit("setAdmin", true);
                    }else{
                        sessionStorage.setItem("admin", false);
                        that.$store.commit("setAdmin", false);
                    }
                    
                }else{
                    that.loginErrMsg = resource.data.data;
                }
            })
        },

        defineRegister() {
            // 注册
            let that = this;
            let reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;

            if( !that.commin.fn.trim( that.registerNickName ) ) {
                that.registerErr = "昵称不能为空";
                return false;
            }else if( that.commin.fn.trim( that.registerUserName ).length < 6 || that.commin.fn.trim( that.registerUserName ).length > 20 ) {
                that.registerErr = "账号不能小于6位或大于20位";
                return false;
            }else if( that.registerPaw.length < 6 || that.registerPaw.length > 20 ) {
                that.registerErr = "密码不能小于6位或大于20位";
                return false;
            }else if( that.registerPaw !== that.registeredPaw ) {
                that.registerErr = "两次密码不一致";
                return false;
            }
            that.register();
        },
        register() {
            let that = this;
            let data = new FormData();
            data.append("nickname", that.commin.fn.trim( that.registerNickName ));
            data.append("username", that.commin.fn.trim( that.registerUserName ));
            data.append("password", that.$md5(that.registeredPaw));
            that.allApi.register(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    that.registerNickName = null;
                    that.registerUserName = null;
                    that.registerPaw = null;
                    that.registeredPaw = null;
                    that.registerErr = "";
                    that.type = "login";
                }else{
                    that.registerErr = resource.data.data;
                }
            })
        },
        routerReload() {
            let that = this;
            that.$router.push("/")
            // that.$store.commit("setIsRouterAlive", false);
            // that.$nextTick(()=>{
            //     that.$store.commit("setIsRouterAlive", true);
            // })
        },
        close() {
            let that = this;
            that.$store.commit("setIsShowLoginBox", false);
        }
    }
}
</script>

<style lang="scss" scoped>
    .loginBox{
        background-image: url('../assets/imgs/login/login_bg.png');
        background-position: center;
        background-repeat: no-repeat;
        // padding-top: 120px;
        width: 100%;
        height: 100%;
        position: relative;
        >div{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1200px;
            // margin: 0 auto;
            >img{
                width: 190px;
                height: 68px;
                margin-bottom: 48px;
                display: block;
            }
            >.loginCon{
                width: 366px;
                margin: 0 auto;
                >h2 {
                    font-size: 30px;
                    text-align: center;
                    margin-bottom: 42px;
                    color: #fff;
                }
                >.loginUserNameBox,
                .loginPasswordBox{
                    width: 100%;
                    height: 50px;
                    background: #fff;
                    margin-bottom: 35px;
                    border-radius: 10px;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    >.icon{
                        width: 32px;
                        height: 32px;
                        background-image: url('../assets/imgs/login/userName.png');
                        background-repeat: no-repeat;
                        background-position: center;
                        margin-right: 10px;
                        margin-left: 16px;
                    }
                    >i{
                        display: block;
                        height: 28px;
                        width: 2px;
                        background: #1EA9E2;
                    }
                    >input{
                        display: block;
                        width: 0%;
                        flex: 1;
                        outline: none;
                        border: 0;
                        padding: 0 16px;
                        font-size: 17px;
                        @include secondary_color(#999);
                        line-height: 50px;
                    }
                }
                >.loginPasswordBox {
                    margin-bottom: 15px;
                    >.icon{
                        background-image: url('../assets/imgs/login/pwd.png');
                    }
                    >.hidePwd{
                        background-image: url('../assets/imgs/login/close_eye_btn.png');
                        background-repeat: no-repeat;
                        background-position: center;
                        width: 24px;
                        height: 16px;
                        margin-right: 24px;
                        cursor: pointer;
                        &.showPwd{
                            background-image: url('../assets/imgs/login/open_eye_btn.png');
                        }
                    }
                }
                >.otherBtn{
                    overflow: hidden;
                    margin-bottom: 35px;
                    >p{
                        color: #fff;
                        font-size: 18px;
                        cursor: pointer;
                    }
                    >.registerBtn{
                        float: right;
                    }
                }
                >.loginBtn{
                    background-image: url('../assets/imgs/login/btn_login.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    height: 50px;
                    cursor: pointer;
                    margin-bottom: 20px;
                }
                >.errMsg{
                    color: #FF0000;
                    font-size: 18px;
                    height: 20px;
                    line-height: 20px;
                    margin-bottom: 20px;
                    text-align: center;
                }
                >.otherLoginBtn {
                    >p{
                        color: #fff;
                        font-size: 18px;
                        line-height: 18px;
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    >div{
                        height: 65px;
                        background-image: url('../assets/imgs/login/wechat_login.png');
                        background-repeat: no-repeat;
                        background-position: center;
                        cursor: pointer;
                    }
                }
            }
            >.versionCon{
                width: 366px;
                margin: 0 auto;
                >h2 {
                    font-size: 24px;
                    text-align: center;
                    margin-bottom: 48px;
                    color: #fff;
                }
                >p{
                    font-size: 30px;
                    text-align: center;
                    margin-bottom: 70px;
                    color: #fff;
                }
                >div:first-of-type{
                    margin-bottom: 110px;
                    display: flex;
                    align-items: center;
                    height: 47px;
                    >div:first-of-type{
                        background-image: url('../assets/imgs/login/versions.png');
                        background-repeat: no-repeat;
                        background-position: center;
                        height: 42px;
                        width: 42px;
                        margin-right: 16px;
                    }
                    >p{
                        font-size: 24px;
                        color: #fff;
                        margin-right: 18px;
                        padding-right: 8px;
                        line-height: 24px;
                        border-right: 1px solid #fff;
                    }
                    >div:last-of-type{
                        width: 0%;
                        flex: 1;
                        position: relative;
                        height: 47px;
                        border-radius:5px;
                        background: #fff;
                        >p{
                            position: relative;
                            font-size: 24px;
                            color: #333333;
                            line-height: 47px;
                            padding: 0 12px 0 25px; 
                            >i{
                                position: absolute;
                                right: 12px;
                                height: 100%;
                                width: 24px;
                                top: 0;
                                background-image: url('../assets/imgs/login/more_version_icon.png');
                                background-repeat: no-repeat;
                                background-position: center;
                            }
                        }
                        >ul{
                            background: #fff;
                            border-radius:5px;
                            position: absolute;
                            left: 0;
                            top: 49px;
                            width: 100%;
                            padding: 0 12px 0 25px; 
                            max-height: 220px;
                            overflow-y: auto;
                            &::-webkit-scrollbar {/*滚动条整体样式*/
                                width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
                            }
                            &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                                border-radius: 10px;
                                box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                                background: rgba($color: #000000, $alpha: .5);
                            }
                            &::-webkit-scrollbar-track {/*滚动条里面轨道*/
                                display: none;
                            }
                            >li{
                                line-height: 44px;
                                font-size: 24px;
                                @include dominant_color(#1c1c1c);
                                cursor: pointer;
                                &:hover{
                                    @include dominant_color_act(#1AA7E0);
                                }
                            }
                        }
                    }
                }
                >div:last-of-type{
                    height: 50px;
                    background-image: url('../assets/imgs/login/definite_btn.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    cursor: pointer;
                }
            }
            >.registerCon{
                width: 366px;
                margin: 0 auto;
                >h2 {
                    font-size: 30px;
                    text-align: center;
                    margin-bottom: 60px;
                    color: #fff;
                }
                >ul{
                    >li {
                        height: 40px;
                        margin-bottom: 20px;
                        position: relative;
                        display: flex;
                        >p{
                            font-size: 24px;
                            color: #FEFEFE;
                            text-align: right;
                            width: 120px;
                        }
                        >input{
                            width: 0%;
                            flex: 1;
                            display: block;
                            border-radius: 5px;
                            background: #fff;
                            padding: 0 10px;
                            @include secondary_color(#999);
                            font-size: 17px;
                            border: 0;
                            outline: none;
                        }
                        >span{
                            position: absolute;
                            right: -15px;
                            color: #FEFEFE;
                            font-size: 24px;
                            line-height: 40px;
                        }
                        >div{
                            width: 0%;
                            flex: 1;
                            display: flex;
                            align-items: center;
                            >input{
                                width: 115px;
                                height: 100%;
                                display: block;
                                border-radius: 5px;
                                background: #fff;
                                padding: 0 10px;
                                @include secondary_color(#999);
                                font-size: 17px;
                                border: 0;
                                outline: none;
                                margin-right: 10px;
                            }
                            >div{
                                width: 0%;
                                flex: 1;
                                background: #65D1FE;
                                color: #fff;
                                line-height: 30px;
                                text-align: center;
                                font-size: 16px;
                                border-radius: 2px;
                                cursor: pointer;
                            }
                        }
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
                >div:last-of-type{
                    height: 50px;
                    background-image: url('../assets/imgs/login/definite_btn.png');
                    background-repeat: no-repeat;
                    background-position: center;
                    cursor: pointer;
                    margin-top: 40px;
                    margin-bottom: 20px;
                }
                >.errMsg{
                    color: #FF0000;
                    font-size: 18px;
                    text-align: center;
                }
            }
        }
    }
</style>
